import { Injectable } from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {User} from '../model/user';
import {Observable, throwError} from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import {StorageService} from '../../core/storage/storage.service';
import { AuthFacade } from '../../stores/auth/facades/auth.facade';

@Injectable()
export class CredentialsInterceptor implements HttpInterceptor {

  private currentUser: User;
  private geotikRefreshToken: string;
  constructor(
    private storage: StorageService,
    private authFacade: AuthFacade
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.currentUser = this.storage.get('currentUser');
    this.geotikRefreshToken = this.storage.get('geotikRefreshToken');

    if (request.url.indexOf('assets/i18n') < 0 && this.currentUser && request.url.indexOf('blob.core.windows.net') < 0) {
      request = request.clone({
        headers: request.headers.append('authorization', `Bearer ${this.currentUser.accessToken}`),
        withCredentials: true
      });
      request = request.clone({
        headers: request.headers.set('accept-language', this.currentUser.language)
      });
    }

    request = request.clone({
      headers: request.headers.set('X-Geotik-Auth-Type', 'header')
    });
    if (this.geotikRefreshToken) {
      request = request.clone({
        headers: request.headers.set('X-Geotik-Refresh-Token', `${this.geotikRefreshToken}`)
      });
    }
    return next.handle(request).pipe(map(event => {
      if (event instanceof HttpResponse) {
        if (event.body && event.body.token) {
          this.authFacade.updateToken(event.body.token);
        }
        if (event.headers && event.headers.has('X-Geotik-Refresh-Token'))  {
          this.storage.set('geotikRefreshToken', event.headers.get('X-Geotik-Refresh-Token'));
        }
        if (event.status === 401) {
          this.authFacade.logout();
          return;
        }
      }
      return event;
    }),
      catchError((error: HttpErrorResponse) => {
        if (error && error.error && error.error.token) {
          this.authFacade.updateToken(error.error.token);
        }
        if (error.status === 401
          && request.url.indexOf('login') < 0
          && request.url.indexOf('logout') < 0
          && window.location.href.indexOf('signin') < 0
        ) {
          this.authFacade.logout();
        }

        return throwError(error);
      }));
  }
}
